export type UserFilterType = {
  key?: string;
  role?: string;
  roleFilter?: string;
  userId?: string;
  status?: string;
  groupId?: string;
  companyId?: string;
  branchId?: string;
};

export enum UserLocalStorage {
  KEY = 'userFilterKey',
  ROLE = 'userFilterRole',
  STATUS = 'userFilterStatus',
  GROUP_ID = 'userFilterGroupId',
  COMPANY_ID = 'userFilterCompanyId',
  BRANCH_ID = 'userFilterBranchId',
}
